import { logger } from './logger';

type JwtPayload = {
	exp?: number;
	telegramId?: number;
	telegram_id?: number;
	sub?: string;
};

export const decodeJwt = (token: unknown): JwtPayload | null => {
	try {
		if (typeof token !== 'string') {
			logger.warn('[AuthLayout] Failed to decode JWT: token is not a string', token);
			return null;
		}
		const [, payloadPart] = token.split(".");
		if (!payloadPart) return null;
		const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
		const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
		const json = atob(padded);
		return JSON.parse(json) as JwtPayload;
	} catch (error) {
		logger.warn("[AuthLayout] Failed to decode JWT", error);
		return null;
	}
};

export const isAccessTokenExpired = (token: unknown, skewSeconds = 30) => {
	if (!token) return true;
	const payload = decodeJwt(token);
	if (!payload?.exp) return true;
	const expiresAt = payload.exp * 1000;
	return Date.now() >= expiresAt - skewSeconds * 1000;
};
